import * as React from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { DialogTrigger } from '../dialog/nested/trigger'
import { DialogClose } from '../dialog/nested/close'
import { DialogTitle } from '../dialog/nested/title'
import { DialogDescription } from '../dialog/nested/description'
import { SheetContent } from './nested/content'
import { SheetHeader } from './nested/header'
import { SheetBody } from './nested/body'
import { SheetFooter } from './nested/footer'
import type { PartProps } from '../../lib/part-props'

function Sheet({
  children,
  ...props
}: Omit<PartProps<React.ComponentProps<typeof BaseDialog.Root>>, 'children'> & { children?: React.ReactNode }) {
  return (
    <BaseDialog.Root {...props}>
      <div data-slot="sheet">{children}</div>
    </BaseDialog.Root>
  )
}

Sheet.Trigger = DialogTrigger
Sheet.Content = SheetContent
Sheet.Header = SheetHeader
Sheet.Body = SheetBody
Sheet.Footer = SheetFooter
Sheet.Title = DialogTitle
Sheet.Description = DialogDescription
Sheet.Close = DialogClose

export { Sheet }
